import type {
  KeysOf,
  NormalizedRpcResponse,
  UseRpcOptions,
  UseRpcReturn,
} from '~/types/rpc'

export function useUserInfo<
  DataT = NormalizedRpcResponse<'getUserInfo'>,
  PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
  DefaultT = null,
>(
  options: UseRpcOptions<'getUserInfo', DataT, PickKeys, DefaultT> = {},
  key?: string,
): UseRpcReturn<'getUserInfo', DataT, PickKeys, DefaultT> {
  return useRpc('getUserInfo', key ?? 'useUserInfo', undefined, {
    dedupe: 'cancel',
    ...options,
  })
}
